import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import Transition from 'react-transition-group/Transition';
import { reDraw } from '../../../../../../../helpers/common';
import { propArrayShape, propBool, propFunc, } from '../../../../../../../helpers/custom-prop-types';
import SendOffModalForm from './SendOffModalForm';
const SendOffModal = (props) => {
    const { hideModal, isShow, modalValue, onSubmit } = props;
    const initialValues = useMemo(() => ({
        viewRequest: modalValue,
    }), [modalValue]);
    return (_jsx(Transition, Object.assign({ in: isShow, mountOnEnter: true, onEnter: reDraw, timeout: 500, unmountOnExit: true }, { children: (state) => (_jsx(SendOffModalForm, { enableReinitialize: true, form: 'SendOffModalForm', hideModal: hideModal, initialValues: initialValues, modalState: state, onSubmit: onSubmit })) })));
};
SendOffModal.propTypes = {
    hideModal: propFunc().isRequired,
    isShow: propBool().isRequired,
    modalValue: propArrayShape().isRequired,
    onSubmit: propFunc().isRequired,
};
export default SendOffModal;
